// Real-mode Settings fetcher — swap-in for getSettingsMock() (task [2.5]).
// Relative path; the installed fetch-patch handles VITE_API_URL prefixing, the
// MSAL bearer, and non-2xx rejection. See overview/real.ts header for the full
// contract + the untested-against-real-backend caveat (proposal risk table).

import { z } from 'zod';

import { donutDatumSchema } from '@/api/schemas';
import type { SettingsData } from './mock';

const providerHealthSchema = z.enum(['operational', 'degraded', 'down']);

const providerToggleSchema = z.object({
	id: z.string(),
	label: z.string(),
	enabled: z.boolean(),
});

const providerCardSchema = z.object({
	id: z.string(),
	name: z.string(),
	health: providerHealthSchema,
	enabled: z.boolean(),
	usagePct: z.number(),
	region: z.string(),
	toggles: z.array(providerToggleSchema),
});

const settingsDataSchema = z.object({
	providers: z.array(providerCardSchema),
	usageSplit: z.array(donutDatumSchema),
});

export async function getSettings(): Promise<SettingsData> {
	const response = await fetch('/settings');
	const json: unknown = await response.json();
	return settingsDataSchema.parse(json);
}
